import React from 'react'


type SubmitButtonData = {
  text: string,

  onClick?: () => void,
  isDisabled?: boolean,
  className?: string,
  primary?: boolean,
  outline?: boolean,
  id?: string
}


export default function SubmitButton({
  primary: primaryProp = true,
  isDisabled: isDisabledProp = false,
  outline: outlineProp = false,
  ...props
}: SubmitButtonData) {

  const getClass = () => {
    const list = ['btn', 'custom-button']
    primaryProp && list.push('btn-primary')
    outlineProp && list.push('btn-outline')
    isDisabledProp && list.push('btn-disabled')
    props.className && list.push(props.className)
    return list.join(' ')
  }

  return <input
    id={props.id}
    disabled={isDisabledProp}
    onClick={props.onClick}
    type="submit"
    className={getClass()}
    value={props.text}
  />
}
